import { polyfill } from 'es6-promise';
polyfill();
